import { all } from 'route-data/all';
import { menuFetcher } from 'redux/fetchers/menu';
import { footerFetcher } from 'redux/fetchers/footer';

export const navigationFetcher = all(menuFetcher, footerFetcher);
